<template>
  <v-card outlined class="backoffice-table" style="box-shadow: none !important">
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :server-items-length="totalItems"
      hide-default-footer
      @page-count="pageCount = $event"
      @update:page="requestPage($event)"
      class="elevation-1"
      :loading="loading"
      :mobile-breakpoint="0"
    >
      <template v-slot:top>
        <v-toolbar flat color="transparent">
          <v-spacer></v-spacer>
          <v-text-field
            class="search-feild"
            v-model="search"
            append-icon="mdi-magnify"
            placeholder="Pesquisar por"
            dense
            solo
            flat
            filled
            hide-details
            clearable
            @keydown.enter="getItems(0, itemsPerPage)"
          ></v-text-field>
          <!-- Create/Edit Dialog -->
          <v-dialog
            v-model="dialog"
            max-width="600px"
            content-class="backoffice-dialog"
          >
            <v-card>
              <!-- Close X button -->
              <v-toolbar flat color="#EBEFF3">
                <v-btn
                  icon
                  @click="dialog = false"
                  class="close-btn"
                  color="#9AABB8"
                  height="40"
                  width="40"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <!-- Input text fields -->
              <v-row>
                <v-col cols="12" class="dialog-frame">
                  <v-row>
                    <v-col>
                      <div class="dialog-title">{{ dialogTitle }}</div>
                    </v-col>
                    <v-col>
                      <!-- Submit payment Dialog -->
                      <v-dialog
                        v-model="submitPaymentDialog"
                        max-width="500px"
                        content-class="backoffice-dialog"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            block
                            large
                            depressed
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            @click="billingPlan = {}"
                            >Adicionar subscrição</v-btn
                          >
                        </template>
                        <v-card>
                          <!-- Close X button -->
                          <v-toolbar flat color="#EBEFF3">
                            <v-btn
                              icon
                              @click="submitPaymentDialog = false"
                              class="close-btn"
                              color="#9AABB8"
                              height="40"
                              width="40"
                            >
                              <v-icon small>mdi-close</v-icon>
                            </v-btn>
                          </v-toolbar>
                          <!-- Input text fields -->
                          <v-row>
                            <v-col cols="12" class="dialog-frame">
                              <div class="dialog-title">
                                Adicionar subscrição
                              </div>
                              <v-row>
                                <v-col>
                                  <div class="dialog-label">
                                    Tipo de subscrição
                                  </div>
                                  <v-select
                                    @input="getBillingPlanById(billingPlan.id)"
                                    :items="billingPlans"
                                    item-text="name"
                                    return-object
                                    v-model="billingPlan"
                                    hide-details
                                    background-color="#D8E0E6"
                                    color="#9aabb8"
                                    solo
                                    flat
                                    height="32px"
                                  >
                                    <template v-slot:item="{ item }">
                                      <div class="v-list-item__content">
                                        <div class="v-list-item__title">
                                          {{ item.name }} -
                                          {{ item.description.split("#")[1] }}
                                        </div>
                                      </div>
                                    </template>
                                    <template v-slot:selection="{ item }">
                                      {{ item.name }} -
                                      {{ item.description.split("#")[1] }}
                                    </template>
                                  </v-select>
                                </v-col>
                              </v-row>
                              <div v-if="billingPlan.billing_cycles">
                                <v-row
                                  v-for="(
                                    cycle, index
                                  ) in billingPlan.billing_cycles"
                                  :key="'billing-cycle-' + index"
                                >
                                  <v-col>
                                    <div class="dialog-label">
                                      {{
                                        cycle.tenure_type == "TRIAL"
                                          ? "Período de avaliação"
                                          : "Período de subscrição"
                                      }}
                                    </div>
                                    <div class="gray-label">
                                      Preço:
                                      {{
                                        cycle.pricing_scheme.fixed_price.value
                                      }}
                                      {{
                                        cycle.pricing_scheme.fixed_price
                                          .currency_code
                                      }}
                                    </div>
                                    <div class="gray-label">
                                      Ciclo de faturação: A cada
                                      {{ cycle.frequency.interval_count }}
                                      dias
                                    </div>
                                    <div class="gray-label">
                                      Número de ciclos de faturação:
                                      {{
                                        cycle.total_cycles > 0
                                          ? cycle.total_cycles
                                          : "Ilimitado"
                                      }}
                                    </div>
                                  </v-col>
                                </v-row>
                              </div>
                            </v-col>
                          </v-row>
                          <!-- Card Actions / Footer button -->
                          <v-card-actions>
                            <v-btn
                              color="primary"
                              block
                              tile
                              depressed
                              @click="addSubscription()"
                              :loading="loading"
                              >Submeter</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-col>
                  </v-row>
                  <!-- ACTIVE -->
                  <v-row>
                    <v-col>
                      <v-switch
                        inset
                        hide-details
                        v-model="editedItem.active"
                        @change="updateRoles(editedItem.admin, 'ADMIN')"
                        label="Activo"
                        class="dialog-switch"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <!-- NAME -->
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Nome</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        hide-details
                        v-model="editedItem.name"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- EMAIL -->
                  <v-row>
                    <v-col>
                      <div class="dialog-label">Email</div>
                      <v-text-field
                        class="dialog-text"
                        dense
                        filled
                        hide-details
                        v-model="editedItem.email"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- BIGODDS -->
                  <v-row>
                    <v-col>
                      <v-switch
                        inset
                        hide-details
                        v-model="editedItem.bigodds"
                        @change="
                          updateRoles(editedItem.bigodds, 'BIGODDS_PREMIUM')
                        "
                        label="Premium Bigodds"
                        class="dialog-switch"
                      ></v-switch>
                      <div style="display: none">{{ editedItem }}</div>
                    </v-col>
                    <v-col v-if="editedItem.bigodds">
                      <DatePicker
                        style="height: 40px"
                        :date="getDate('bigodds')"
                        @dateSelected="addManualSubscription($event, 'Bigodds')"
                      ></DatePicker>
                    </v-col>
                  </v-row>
                  <!-- APPOSTA -->
                  <v-row>
                    <v-col>
                      <v-switch
                        inset
                        hide-details
                        v-model="editedItem.apposta"
                        @change="
                          updateRoles(editedItem.apposta, 'APPOSTA_PREMIUM')
                        "
                        label="Premium Apposta"
                        class="dialog-switch"
                      ></v-switch>
                    </v-col>
                    <v-col v-if="editedItem.apposta == true">
                      <DatePicker
                        v-if="editedItem.apposta"
                        :date="getDate('apposta')"
                        @dateSelected="addManualSubscription($event, 'Apposta')"
                      ></DatePicker>
                    </v-col>
                  </v-row>
                  <!-- MODERATOR -->
                  <v-row>
                    <v-col>
                      <v-switch
                        inset
                        hide-details
                        v-model="editedItem.moderator"
                        @change="updateRoles(editedItem.moderator, 'MODERATOR')"
                        label="Moderator"
                        class="dialog-switch"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <!-- ADMIN -->
                  <v-row>
                    <v-col>
                      <v-switch
                        inset
                        hide-details
                        v-model="editedItem.admin"
                        @change="updateRoles(editedItem.admin, 'ADMIN')"
                        label="Admin"
                        class="dialog-switch"
                      ></v-switch>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <!-- Card Actions / Footer button -->
              <v-card-actions>
                <v-btn
                  color="primary"
                  block
                  tile
                  depressed
                  @click="addItem()"
                  :loading="loading"
                  >Submeter</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.roles`]="{ item }">
        <v-chip
          v-for="(role, index) in item.roles"
          :key="'role-' + item.name + index"
          class="market-chip"
          label
          small
          :class="
            role == 'APPOSTA_PREMIUM'
              ? 'result-warning'
              : role == 'BIGODDS_PREMIUM'
              ? 'result-success'
              : role == 'ADMIN'
              ? 'result-fail'
              : ''
          "
          >{{
            role == "APPOSTA_PREMIUM"
              ? "A.PREMIUM"
              : role == "BIGODDS_PREMIUM"
              ? "B.PREMIUM"
              : role
          }}</v-chip
        >
      </template>
      <!-- Subscriptions Expiry -->
      <template v-slot:[`item.subscriptions`]="{ item }">
        {{
          item.subscriptions[0]
            ? $moment(item.subscriptions[0].endDate, "x").format("DD-MM-YYYY")
            : "-"
        }}
        /
        {{
          item.subscriptions[1]
            ? $moment(item.subscriptions[1].endDate, "x").format("DD-MM-YYYY")
            : "-"
        }}
      </template>
      <!-- Next Payment -->
      <template v-slot:[`item.subscriptionIds`]="{ item }">
        {{
          item.subscriptions[0] && item.subscriptions[0].paymentType != "Manual"
            ? $moment(item.subscriptions[0].endDate, "x").format("DD-MM-YYYY")
            : "-"
        }}
        /
        {{
          item.subscriptions[1] && item.subscriptions[1].paymentType != "Manual"
            ? $moment(item.subscriptions[1].endDate, "x").format("DD-MM-YYYY")
            : "-"
        }}
      </template>
      <!-- Actions Template -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          depressed
          dark
          color="#D8E0E6"
          class="gray-button"
          @click="editItem(item)"
          style="margin-right: 8px"
          >Editar</v-btn
        >
        <RemoveItem
          :target="'utilizador'"
          @remove-item="deleteItem(item)"
        ></RemoveItem>
      </template>
      <template v-slot:[`body.append`]="{ headers }">
        <tr v-for="n in itemsPerPage - items.length" :key="'tr-' + n">
          <td :colspan="headers.length"></td>
        </tr>
      </template>
    </v-data-table>
    <div class="pagination">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-card>
</template>

<style scoped>
.gray-label {
  font-family: Gilroy-SemiBold;
  font-size: 11px;
  line-height: 16px;
  color: #bcc5cc;
}
.backoffice-table >>> tr td:nth-child(1) {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.backoffice-table >>> tr td:nth-child(4),
.backoffice-table >>> tr td:nth-child(5) {
  max-width: 96px;
}

.backoffice-table >>> .text-end {
  min-width: 160px;
}

.pagination >>> .v-application .primary {
  background-color: red !important;
}
@media only screen and (max-width: 1024px) {
  .backoffice-table >>> .v-data-table__wrapper {
    overflow: auto;
  }
  .backoffice-table >>> table {
    width: 1180px;
  }
}
</style>

<script>
import Vue from "vue";

import DatePicker from "@/components/DatePicker";
import RemoveItem from "@/components/RemoveItem";
import ApiService from "@/services/api.service";

export default Vue.extend({
  name: "UsersTable",
  components: {
    DatePicker,
    RemoveItem,
  },
  props: { data: {} },
  data: () => ({
    dialog: false,
    submitPaymentDialog: false,
    loading: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    search: "",
    headers: [
      { text: "Nome", value: "name", sortable: false },
      { text: "Email", value: "email", sortable: false },
      { text: "Tipo", value: "roles", sortable: false },
      { text: "Validade", value: "subscriptions", sortable: false },
      { text: "Próximo Pagamento", value: "subscriptionIds", sortable: false },
      { text: "", align: "end", value: "actions", sortable: false },
    ],
    items: [],
    billingPlans: [],
    totalItems: 0,
    dialogTitle: "",
    editedItem: {
      id: "",
      uid: "",
      name: "",
      email: "",
      active: false,
      roles: [],
      subscriptions: [],
      apposta: false,
      bigodds: false,
      moderator: false,
      admin: false,
    },
    emptyItem: {
      id: "",
      uid: "",
      name: "",
      email: "",
      active: false,
      roles: [],
      subscriptions: [],
      apposta: false,
      bigodds: false,
      moderator: false,
      admin: false,
    },
    billingPlan: {}
  }),
  created() {
    this.getBillingPlans();
    this.getItems(0, this.itemsPerPage);
  },
  methods: {
    getBillingPlans() {
      this.loading = true;
      ApiService.getBillingPlans().then(
        (response) => {
          this.billingPlans = response.data.plans;
          this.loading = false;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    getBillingPlanById(planId) {
      this.loading = true;
      ApiService.getBillingPlanById(planId).then(
        (response) => {
          this.billingPlan = this.$lodash.cloneDeep(response.data);
          this.loading = false;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    getItems(page, size) {
      this.loading = true;
      ApiService.getAdminUsers(this.search, page, size).then(
        (response) => {
          this.items = response.data.users;
          this.totalItems = response.data.totalElements;
          this.loading = false;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    requestPage(page) {
      this.getItems(page - 1, this.itemsPerPage);
    },
    editItem(item) {
      this.dialogTitle = "Editar utilizador";
      this.editedItem = this.$lodash.cloneDeep(item);

      this.editedItem.apposta = this.editedItem.roles.includes(
        "APPOSTA_PREMIUM"
      );
      this.editedItem.bigodds = this.editedItem.roles.includes(
        "BIGODDS_PREMIUM"
      );
      this.editedItem.moderator = this.editedItem.roles.includes("MODERATOR");
      this.editedItem.admin = this.editedItem.roles.includes("ADMIN");

      this.dialog = true;
    },
    deleteItem(item) {
      this.loading = true;
      ApiService.deleteUser(item.uid).then(
        (response) => {
          this.loading = false;
          this.getItems(this.page - 1, this.itemsPerPage);
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    addItem() {
      this.loading = true;
      ApiService.updateAdminUser(this.editedItem).then(
        (response) => {
          this.dialog = false;
          this.loading = false;
          this.getItems(this.page - 1, this.itemsPerPage);
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    updateRoles(item, role) {
      if (item) {
        this.editedItem.roles.push(role);
      } else {
        this.editedItem.roles = this.removeRole(role);
        if (role.includes("BIGODDS_PREMIUM")) {
          Vue.set(
            this.editedItem,
            "subscriptions",
            this.removeSubscription("Bigodds")
          );
        } else if (role.includes("APPOSTA_PREMIUM")) {
          Vue.set(
            this.editedItem,
            "subscriptions",
            this.removeSubscription("Apposta")
          );
        }
      }
    },
    removeRole(elem) {
      return this.editedItem.roles.filter((item) => item !== elem);
    },
    removeSubscription(elem) {
      return this.editedItem.subscriptions.filter((item) => item.name !== elem);
    },
    addManualSubscription(expiryDate, appName) {
      const now = this.$moment();
      const expiry = this.$moment().add(1, "days");

      const subscriptionPlan = {
        userId: this.editedItem.uid,
        planId: "0",
        name: appName,
        startDate: now.valueOf(),
        endDate: this.$moment(expiryDate).valueOf(),
        paymentType: "Manual",
      };

      const subscriptionIndex = this.editedItem.subscriptions.findIndex((x) =>
        x.name.includes(appName)
      );
      if (subscriptionIndex >= 0) {
        Vue.set(
          this.editedItem.subscriptions,
          subscriptionIndex,
          subscriptionPlan
        );
      } else {
        this.editedItem.subscriptions.push(subscriptionPlan);
      }
    },
    addSubscription() {
      const intervalCount = parseInt(
        this.billingPlan.billing_cycles[1].frequency.interval_count
      );

      const now = this.$moment();
      const expiry = this.$moment().add(intervalCount, "days");

      const subscriptionPlan = {
        userId: this.editedItem.uid,
        planId: this.billingPlan.id,
        name: this.billingPlan.name,
        startDate: now.valueOf(),
        endDate: expiry.valueOf(),
        paymentType: "Transferência",
      };

      const appName = subscriptionPlan.name.toLowerCase();

      if (appName.includes("bigodds")) {
        const role = "BIGODDS_PREMIUM";
        const roleIndex = this.editedItem.roles.findIndex((x) => x == role);
        if (roleIndex >= 0) {
          Vue.set(this.editedItem.roles, roleIndex, role);
        } else {
          this.editedItem.roles.push(role);
        }

        const subscriptionIndex = this.editedItem.subscriptions.findIndex((x) =>
          x.name.toLowerCase().includes("bigodds")
        );
        if (subscriptionIndex >= 0) {
          Vue.set(
            this.editedItem.subscriptions,
            subscriptionIndex,
            subscriptionPlan
          );
        } else {
          this.editedItem.subscriptions.push(subscriptionPlan);
        }

        this.editedItem.bigodds = true;
      } else if (subscriptionPlan.name.toLowerCase().includes("apposta")) {
        const role = "APPOSTA_PREMIUM";
        const roleIndex = this.editedItem.roles.findIndex((x) => x == role);
        if (roleIndex >= 0) {
          Vue.set(this.editedItem.roles, roleIndex, role);
        } else {
          this.editedItem.roles.push(role);
        }

        const subscriptionIndex = this.editedItem.subscriptions.findIndex((x) =>
          x.name.toLowerCase().includes("bigodds")
        );
        if (subscriptionIndex >= 0) {
          Vue.set(
            this.editedItem.subscriptions,
            subscriptionIndex,
            subscriptionPlan
          );
        } else {
          this.editedItem.subscriptions.push(subscriptionPlan);
        }
        this.editedItem.apposta = true;
      }

      this.submitPaymentDialog = false;
    },
    getIndex(appName) {
      return this.editedItem.subscriptions.findIndex((x) =>
        x.name.toLowerCase().includes(appName)
      );
    },
    getDate(appName) {
      const index = this.getIndex(appName);
      const subscription = this.editedItem.subscriptions[index];
      return subscription
        ? this.$moment(subscription.endDate, "x").format("YYYY-MM-DD")
        : this.$moment().format("YYYY-MM-DD");
    },
  },
});
</script>